import { Link, useParams } from "react-router-dom";
import { useProtectedRouteSession } from "../../shared/session/useProtectedRouteSession";
import { OperatorPageScaffold } from "../../shared/ui/protected/OperatorPageScaffold";

type AdminReviewPlaceholderPageProps = {
  title: string;
  description: string;
  links: Array<{ to: string; label: string }>;
  summary: string;
  notes: string[];
  actions?: Array<{ to: string; label: string }>;
};

export function AdminReviewPlaceholderPage({
  title,
  description,
  links,
  summary,
  notes,
  actions = []
}: AdminReviewPlaceholderPageProps) {
  const { tenantSlug = "unknown-tenant" } = useParams();
  const { routeStatus, sessionStatus, session, errorMessage, isSessionReady } = useProtectedRouteSession(tenantSlug);
  const hasAdminRole = Boolean(session?.member?.roles.includes("admin"));

  return (
    <OperatorPageScaffold
      currentArea="admin"
      tenantSlug={tenantSlug}
      tenantName={session?.tenant.displayName}
      session={session} title={title} description={description} links={links}>
      <div style={{ display: "grid", gap: 16 }}>
        {routeStatus === "checking" || sessionStatus === "loading" ? <p>セッションを確認しています。</p> : null}
        {routeStatus === "redirecting" ? <p>Entry へ移動しています。</p> : null}
        {sessionStatus === "error" ? <p>セッション確認に失敗しました。{errorMessage}</p> : null}
        {routeStatus === "authenticated" && !hasAdminRole ? <p>この画面は admin role のみ利用できます。</p> : null}

        {isSessionReady && hasAdminRole ? (
          <>
            <div
              style={{
                padding: 12,
                borderRadius: 12,
                background: "#fff7e8",
                border: "1px solid #f0d9a7",
                display: "grid",
                gap: 8
              }}
            >
              <strong>未実装 / API未接続</strong>
              <div style={{ fontSize: 14 }}>{summary}</div>
            </div>

            {actions.length > 0 ? (
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {actions.map((action) => (
                  <Link
                    key={action.to}
                    to={action.to.replace(":tenantSlug", tenantSlug)}
                    style={{
                      display: "inline-block",
                      padding: "10px 12px",
                      borderRadius: 10,
                      border: "1px solid #ccc",
                      textDecoration: "none",
                      color: "inherit"
                    }}
                  >
                    {action.label}
                  </Link>
                ))}
              </div>
            ) : null}

            <section style={{ display: "grid", gap: 8 }}>
              <h2 style={{ margin: 0, fontSize: 18 }}>review メモ</h2>
              <ul style={{ margin: 0, paddingLeft: 20, display: "grid", gap: 6 }}>
                {notes.map((note) => (
                  <li key={note}>{note}</li>
                ))}
              </ul>
            </section>
          </>
        ) : null}
      </div>
    </OperatorPageScaffold>
  );
}
